import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PublicLayout } from "@/components/PublicLayout";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [valid, setValid] = useState(null);
  const [pw, setPw] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    if (!token) return setValid(false);
    api.get(`/auth/verify-reset-token/${token}`).then(() => setValid(true)).catch(() => setValid(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset! Please log in.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-5 pt-14">
        <div className="mm-card p-8">
          <h1 className="text-3xl font-bold">Choose a new password</h1>
          {valid === false && (
            <div className="mt-4" data-testid="reset-invalid">
              <p className="text-mm-muted">This reset link is invalid or has expired.</p>
              <Link to="/forgot-password" className="mm-btn mt-4">Request a new one</Link>
            </div>
          )}
          {valid && (
            <form onSubmit={submit} className="space-y-3 mt-6">
              <input className="mm-input" type="password" required placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
              <button className="mm-btn w-full" data-testid="reset-password-submit">Reset password</button>
            </form>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
